import React from 'react';

const LoginPrompt = ({ message = "Please log in to continue" }) => {
 const handleDiscordLogin = () => {
   const currentPath = window.location.pathname;
   window.location.href = `/oauth/login/discord/?next=${encodeURIComponent(currentPath)}`;
 };

 return (
   <div className="p-8">
     <h2 className="text-heading-sm font-extrabold uppercase mb-6 text-ink">{message}</h2>
     <button
       onClick={handleDiscordLogin}
       className="bg-discord text-white border-[1.5px] border-discord px-8 py-3 rounded-lg font-bold uppercase tracking-wide text-body-sm hover:brightness-110 transition-all"
     >
       Sign in with Discord
     </button>
   </div>
 );
};

export default LoginPrompt;
